export const filterTypes = {
  'DEVICE_TYPE': 'deviceType',
  'PARTNER_TYPE': 'partnerType'
}
